import { render, staticRenderFns } from "./discrepancy-transaction-action-column.vue?vue&type=template&id=98abca78&scoped=true"
import script from "./discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
export * from "./discrepancy-transaction-action-column.vue?vue&type=script&lang=js"
import style0 from "./discrepancy-transaction-action-column.vue?vue&type=style&index=0&id=98abca78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98abca78",
  null
  
)

export default component.exports